import type { ReactNode } from 'react';

import styles from './NetworkCard.module.scss';

interface INetworkCardProps {
    imgSrc: string;
    title: string;
    text: ReactNode;
}

const NetworkCard: React.FC<INetworkCardProps> = ({ imgSrc, title, text }) => {
    return (
        <div className={styles.networkBlock}>
            <div className={styles.networkBlock_img}>
                <img src={imgSrc} alt={title} />
            </div>
            <div className={styles.networkBlock_text}>
                <h3>{title}</h3>
                <p>{text}</p>
            </div>
        </div>
    );
};

export default NetworkCard;
